<template>
    <div class="content mt20">
       <div class="account-content bgfff">
         <taskOrdersMenu></taskOrdersMenu>
       </div>
       <div class="account-bd">&nbsp;</div>
       <div class="bgfff">
            <div class="bd clearfix">
                <router-link to="/taskOrders/createTasks" class="btn btn-blue fl"><i class="icons add-blue-icon"></i>创建任务</router-link>
                <span class="fl mt5 ml20">指令类型：</span>
                <div class="dropdown-toggle fl">
                    <div class="dropdown">
                        <span>{{typeWord}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li @click="OrderType(0)">
                               <a :class="(typeCurrent==0)?'active':''" href="javascript:void(0);">全部</a>
                            </li>
                            <li @click="OrderType(1)">
                               <a :class="(typeCurrent==1)?'active':''" href="javascript:void(0);">转发</a>
                            </li>
                            <li @click="OrderType(2)">
                               <a :class="(typeCurrent==2)?'active':''" href="javascript:void(0);">评论</a>
                            </li>
                            <li @click="OrderType(3)">
                               <a :class="(typeCurrent==3)?'active':''" href="javascript:void(0);">点赞</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="search fr">
                    <div class="search fl">
                        <input type="text" v-model="Searchtitle" class="input-text" name="search" @keyup="searcBotton" placeholder="请输入文章标题">
                    </div>
                    <button class="btn btn-blue" @click="searcBotton"><i class="icons search-icon"></i></button>
                </div>
            </div>
            <div class="">
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <div class="clearfix listloop-wrap profile active" v-for="(item,index) in mediaList" :key="index">
                    <div class="clearfix">
                        <div class="fl profile-img">
                            <img :src="item.newsImg" width="180" height="100" />
                        </div>
                        <div class="fr profile-btn mt40">
                            <div class="details-a " :class="curr==index?'active':''" @click="ViewDetails(item.pid,index)"><span class="color-blue">查看详情</span><i class="icons icons-down fr"></i></div>
                        </div>
                        <div class="profile-info">
                            <h3 class="profile-tit"><a :href="item.newsUrl" target="_blank">{{item.newsTitle}}</a></h3>
                            <div class="profile-status">
                                <span class="color_gray time"><i class="icons time-icon"></i>发送时间：{{item.addTime}}</span>
                                <span class="ml10 color_gray">指令类型：{{item.type}}</span>
                            </div>
                            <p class="profile-art fs12 mt30">指令要求：{{item.remark}}</p>
                        </div>
                    </div>
                    <div class="handle-content" v-show="curr==index">
                        <div class="handle-t mt5 w100">
                            <a href="javaScript:void(0)" class="curr" :class="(status==1)?'color-blue':'color-gray'" @click="chulClick(1)">已处理</a>
                            <a href="javaScript:void(0)" class="ml30" :class="(status==0)?'color-blue':'color-gray'" @click="chulClick(0)">未处理</a>
                        </div>
                        <table class="table table-issue" width="100%" border="0" cellpadding="0" cellspacing="0" v-if="item.types===1">
                            <colgroup>
                                <col width="25%">
                                <col width="25%">
                                <col width="25%">
                                <col width="10%">
                            </colgroup>
                            <thead>
                                <tr v-if="status==0">
                                    <th>
                                        <div class="checkbox fl" v-if="status2==0">
                                            <input type="checkbox" class="checkbox-i" v-model="checkedAll" id="all" @click="selectAll()" :checked="checkedSel==true">
                                            <span class="checkbox-ico"></span>
                                        </div>
                                        <span class="ml5">媒体号</span>
                                    </th>
                                    <th>平台</th>
                                    <th>运营账号</th>
                                    <th>提醒</th>
                                </tr>
                                <tr v-if="status==1">
                                    <th>
                                        <span class="ml5">媒体号</span>
                                    </th>
                                    <th>平台</th>
                                    <th>运营账号</th>
                                    <th>查看原文</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr colspan="4">
                                    <div class="no-data" v-if="nodata1"><span class="text">没有数据哦...</span></div>
                                </tr>
                                <tr v-for="(item1,index) in orderList" :key="index">
                                    <td v-if="status==0">
                                        <div class="checkbox fl" v-if="item1.status==0">
                                            <input type="checkbox" @click="select(item1.id,index)" :value="item1.id" v-model="checked" :id="item1.id" :checked="checkedSel==true" class="checkbox-i">
                                            <span class="checkbox-ico"></span>
                                        </div> 
                                        <span class="ml5">{{item1.nickname}}</span>
                                    </td>
                                    <td v-if="status==1">
                                        <span class="ml5">{{item1.nickname}}</span>
                                    </td>
                                    <td>{{item1.groupZh}}</td>
                                    <td>
                                        {{item1.mobile}}
                                    </td>
                                    <td v-if="status==0">
                                        <a href="javaScript:void(0)" class="color-blue" v-if="item1.status==0" @click="SendReminder(item1.id)">发送提醒</a>
                                        <a href="javaScript:void(0)" class="color-gray" v-if="item1.status==1">已发送</a>
                                    </td>
                                    <td v-if="status==1">
                                        <a :href="item1.url" target="_blank" class="color-blue" >查看原文</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table table-issue" width="100%" border="0" cellpadding="0" cellspacing="0" v-if="item.types==2||item.types==3">
                            <colgroup>
                                <col width="25%">
                                <col width="25%">
                                <col width="10%">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th v-if="status==0">
                                        <div class="checkbox fl" v-if="status2==0">
                                            <input type="checkbox" class="checkbox-i" v-model="checkedAll" id="all" @click="selectAll()" :checked="checkedSel==true">
                                            <span class="checkbox-ico"></span>
                                        </div>
                                        <span class="ml5">运营账号</span>
                                    </th>
                                    <th v-if="status==1">
                                        <span class="ml5">运营账号</span>
                                    </th>
                                    <th>用户组</th>
                                    <th v-if="status==0">提醒</th>
                                    <th v-if="status==1">查看</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item1,index) in orderList" :key="index">
                                    <td v-if="status==0">
                                        <div class="checkbox fl" v-if="item1.status==0">
                                            <input type="checkbox" @click="select(item1.id,index)" :value="item1.id" v-model="checked" :id="item1.id" :checked="checkedSel==true" class="checkbox-i">
                                            <span class="checkbox-ico"></span>
                                        </div> 
                                        <span class="ml5">{{item1.mobile}}</span>
                                    </td>
                                    <td v-if="status==1">
                                        <span class="ml5">{{item1.mobile}}</span>
                                    </td>
                                    <td>{{item1.level}}</td>
                                    <td v-if="status==0">
                                        <a href="javaScript:void(0)" class="color-blue" v-if="item1.status==0" @click="SendReminder(item1.id)">发送提醒</a>
                                        <a href="javaScript:void(0)" class="color-gray" v-if="item1.status==1">已发送</a>
                                    </td>
                                    <td v-if="status==1">
                                        <a  class="color-blue" @click="seeImg(item1.url)">查看截图</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- 分页 -->
            <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            
       </div>
       <!-- 查看图片 -->
        <Dialog ref="seeImgModal" :callback="seeImgSave" :modalFoot="false" width="600" title="查看截图">
            <div slot="mdBox">
                <img :src="imgUrl" width="100%" />
            </div>
        </Dialog>
  	</div>
</template>
<script>
import Page from '@/components/page'
import Dialog from '../../components/dialog.vue'
import taskOrdersMenu from './taskOrdersMenu.vue'
export default {
    components:{Dialog,Page,taskOrdersMenu},
    data() {
        return {
           mediaList:[],//指令列表
           orderList:[],//指令详情列表
           currentPage:1,//当前条数
           limit:10,//每页显示条数
           totalCount:0,//总条数
           typeId:1,//id
           imgUrl:'',//图片url
           typeCurrent:0,//指令类型
           Searchtitle:'',//搜索
           typeWord:'全部',//指令类型文字
           curr:-1,
           pid:'',//指令详情pid
           status:'',//指令详情status
           status1:'',//是否提醒
           status2:0,//是否全部提醒
           checked:[],//单选
           checkedAll:false,//是否全选
           list:'',//选择列表
           checkedSel:false,
           nodata:false,
           nodata1:false,

        }
    },
    mounted() {
        let that = this;
        if(that.$route.query.type==undefined){
            that.typeWord = '全部'
            that.typeCurrent = 0;
        }else{
            that.typeWord = that.$route.query.type1;
            that.typeCurrent = that.$route.query.type;
            
        }
        that.dataAjax(0);
    },
    created() {
		
    },
    methods: {
        seeImg(url){//查看截图
            this.$refs.seeImgModal.showMaskFun();
            this.imgUrl = url;
            //console.log(this.imgUrl);

        },
        seeImgSave(){

        },
        chulClick(type){//点击已处理 未处理
            let that = this;
            that.status = type;
           // console.log(type);
            that.dataAjax2();

        },
        selectAll(){//全选
            let that = this;
            if(that.checkedAll){
                // 全不选
                that.checked = [];
                that.checkedSel =false;
            }else{
                // 全选
                that.checked = [];
                that.checkedSel =true;
                that.orderList.forEach((item)=>{
                    that.checked.push(item.id);
                    
                })
            }
        },
        select(id,i){//多选
            let that = this;  
            let idArr= [];    
            
            if(this.checked.includes(id)){
                that.checkedSel =false;
                this.checked=this.checked.filter(function (ele){return ele != id;});
			}else{
                that.checkedSel =true;
                this.checked.push(id);
                that.checked = Array.from(new Set(that.checked));
			}
        },
        SendReminder(id){//点击提醒
            let that = this;
            that.typeId = that.checked.join(",");
            let text = '';
            that.$api.post('/order/remind',{id:that.typeId},r=>{
                that.$parent.returnCode(r,function(){
                    that.text = r.msg;
                    that.$utils.alertText(that.text,100,2000);
                    that.status1 = 1;
                    that.dataAjax2();
              })
            });
        },
        ViewDetails(id,index){//点击展开详情
            let that = this;
            that.pid= id;
            that.status = 0;
            that.curr = that.curr == index ? -1 : index; 
            if(that.curr == -1){
                return;
            }else{
                that.dataAjax2();
            }
            
                      
        },
       searcBotton(){//搜索
            let that = this;
            // if(that.Searchtitle==''){
            //     return;
            // }
            that.dataAjax(0);
        },
        OrderType(type){//指令类型选择
            let that = this;
            that.typeCurrent = type;
            if(type==0){
                that.typeWord = '全部'
            }else if(type==1){
                that.typeWord = '转发'
            }else if(type==2){
                that.typeWord = '评论'
            }else if(type==3){
                that.typeWord = '点赞'
            }
            that.$router.push({
                path: '/taskOrders/issueOrders',
                query: {
                    type: type,
                    type1:that.typeWord,
                }
            });
            that.typeCurrent = that.$route.query.type;
            that.typeWord = that.$route.query.type1;

            that.dataAjax(0);
        },
        getTableData(type){//分页
            let that = this;
            type = that.currentPage;

            that.dataAjax();
        
        },
        dataAjax(cPage){//指令列表
            let that = this;
            let url = '';
            cPage = 1;
            if(cPage ==0){
                that.currentPage =1;
            }
            that.$parent.loadModal(true,'正在加载...');
            that.$api.post('/order/publishlist',{page:that.currentPage,pagesize:that.limit,type:that.typeCurrent,title:that.Searchtitle},r=>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.mediaList=r.data.list;
                    that.pid = r.data.list.pid;
                    that.totalCount = Number(r.data.total);
                    if(that.mediaList.length<=0){
                       that.nodata = true;
                    }else{
                       that.nodata = false;
                       
                   }
              })
            })
       },
       dataAjax2(){//指令详情
            let that = this;
            let url = '';
            that.$parent.loadModal(true,'正在加载...');
            that.$api.post('/order/detail',{pid:that.pid,status:that.status},r=>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.orderList=r.data.list;
                    that.status2 = r.data.status;
                    if(that.orderList.length<=0){
                       that.nodata1 = true;
                    }else{
                        that.nodata1 = false;
                    }

              })
            })
       }
       
    },
    watch:{
        checked(){
            let that = this;
            if(this.checked.length === this.orderList.length){
                that.checkedAll = true;
            } else{
                that.checkedAll = false;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/taskOrders/issueOrders.vue